/* eslint no-unused-vars: 0 */
/* eslint no-constant-condition: 0 */
import React, { useCallback, useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { useForm, useLoadSection } from '~/hooks';
import { stringUtils } from '~/util';
const { hasValue } = stringUtils;
import sectionTypes from '../sectionTypes';
import { BsFillExclamationCircleFill } from 'react-icons/bs';
import { DocumentType } from '~/api/document';
import { useValidation } from '~/hooks/useValidation';
//import moment from "moment";

const initialState = {
    sectionId: 0,
    sectionDetails: [],
    selectedDeed: {},
    hasErrors: true
};


const formatDate = (value) => {
    return hasValue(value)
        ? DateTime.fromISO(value).toLocal().toLocaleString()
        : '';
};


const formatCurrency = value => {
    if (isNaN(parseFloat(value))) return '';
    return parseFloat(value.replace(/,/g, '')).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace(/\.00$/, '');
};

const hasSection = (values, regex, ignore) => {
    return Object.entries(values).some(([key, value]) => !!key.match(regex) && key !== ignore && value && value.length > 0);
};

const validationSchema = {
    book: {},
    page: {},
    countyRegistry: {},
    secbook: {
        validate: (field, data) => {
            if (!hasSection(data, /^sec/, 'securingAmountOf')) return true;
            return field?.length > 0;
        }
    },
    secpage: {
        validate: (field, data) => {
            if (!hasSection(data, /^sec/, 'securingAmountOf')) return true;
            return field?.length > 0;
        }
    },
    seccountyRegistry: {
        validate: (field, data) => {
            if (!hasSection(data, /^sec/, 'securingAmountOf')) return true;
            return field?.length > 0;
        }
    },
    dotbook: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            return field?.length > 0;
        }
    },
    dotpage: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            return field?.length > 0;
        }
    },
    dotcountyRegistry: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            return field?.length > 0;
        }
    },
    dotreBook: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            if (!data.dotreRecordedOn || data.dotreRecordedOn.length === 0) return true;
            return field?.length > 0;
        }
    },
    dotrePage: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            if (!data.dotreRecordedOn || data.dotreRecordedOn.length === 0) return true;
            return field?.length > 0;
        }
    },
    dotreCountyRegistry: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            if (!data.dotreRecordedOn || data.dotreRecordedOn.length === 0) return true;
            return field?.length > 0;
        }
    },
    dotassignedBook: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            if (!data.dotassignedTo || data.dotassignedTo.length === 0) return true;
            return field?.length > 0;
        }
    },
    dotassignedPage: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            if (!data.dotassignedTo || data.dotassignedTo.length === 0) return true;
            return field?.length > 0;
        }
    },
    dotassignedCountyRegistry: {
        validate: (field, data) => {
            if (!hasSection(data, /^dot/)) return true;
            if (!data.dotassignedTo || data.dotassignedTo.length === 0) return true;
            return field?.length > 0;
        }
    },
};

const Review = ({ titleOpinionId, validationResult }) => {
    const [hasErrors, setHasErrors] = useState(false);

    const { onLoad: loadSection } = useLoadSection(sectionTypes.DEED, titleOpinionId);

    const onLoad = useCallback(async data => {
        try {
            return await loadSection(data);
        } catch (e) {
            console.error(e);
        }
    }, [loadSection]);

    const {
        state: { values }
    } = useForm({ initialState, onLoad });
    const recordedOns = hasValue(values.recordedOn)
        ? DateTime.fromISO(values.recordedOn).toLocal()
        : '';
    const secrecordedOn = hasValue(values.secrecordedOn)
        ? DateTime.fromISO(values.secrecordedOn).toLocal()
        : '';
    const dotrecordedOn = hasValue(values.dotrecordedOn)
        ? DateTime.fromISO(values.dotrecordedOn).toLocal()
        : '';
    const dotreRecordedOn= hasValue(values.dotreRecordedOn)
        ? DateTime.fromISO(values.dotreRecordedOn).toLocal()
        : '';
        
    const hasDeed = !!values.documents?.find(doc => doc.type === DocumentType.DEED);
    const hasCopyOfDeed = !!values.documents?.find(doc => doc.type === DocumentType.COPYOFDEED);
    
    var time= recordedOns ? ("At  " + recordedOns.toLocaleString(DateTime.TIME_SIMPLE)) : "";
    var sectime= secrecordedOn ? ("At  " + secrecordedOn.toLocaleString(DateTime.TIME_SIMPLE)) : "";
    var deedoftrusttime= dotrecordedOn ? ("At  " + dotrecordedOn.toLocaleString(DateTime.TIME_SIMPLE)) : "";
    var deedofretrusttime= dotreRecordedOn ? ("At  " + dotreRecordedOn.toLocaleString(DateTime.TIME_SIMPLE)) : "";

    const hasdeeds = hasSection(values, /^sec/);
    const hasSecondDeed = hasSection(values, /^sec/, 'securingAmountOf');
    const hasDeedOfTrust = hasSection(values, /^dot/);
    const copyofdeed = values && values.documents ? values.documents.filter(x => x.type == DocumentType.DEED).map((entry) => {
        return entry.file.path;
    }) : [];
    const copyofdeedsecond = values && values.documents ? values.documents.filter(x => x.type == DocumentType.COPYOFDEED).map((entry) => {
        return entry.file.path;
    }) : [];
    const copyofdeedthird = values && values.documents ? values.documents.filter(x => x.type == DocumentType.DEED_OF_TRUST).map((entry) => {
        return entry.file.path;
    }) : [];

    const [, invalidFields] = useValidation(values, validationSchema);

    useEffect(() => {
        const hasErrors = Object.values(invalidFields).some(field => !!field);
        setHasErrors(hasErrors);
        validationResult(hasErrors);
    }, [invalidFields, validationResult]);

    if (values.sectionId === 0) {
        return (
            <div className="ml-2 mr-5">
                <div className="col-span-12 border-t-2 border-blueGray-30 mt-4 mb-4" />
            </div>
        );
    }

    return (
        <div className="ml-2 mr-5">
            <div className="text-1xl text-blue-60 font-bold mb-3">
                <div className="display:flex; flex-direction:row;">
                    <div className="z-10 flex flex-row h-full  text-xs font-semibold text-blue-60">
                        <div className="mt-1 mb-2">7. <a href={`/StraightFinal/${titleOpinionId}/deedoftust`}>Deed Information</a> </div>
                    </div>
                </div>
            </div>
            <div className="col-span-8 grid grid-cols-8 grid-flow-row gap-x-8 gap-y-1  text-xs mb-4">
                <div className="col-span-8 text-red-600">
                    {hasErrors ?
                        <p className="flex flex-row gap-x-2 mb-2"><BsFillExclamationCircleFill />
                            You have not provided all the required information in this section.</p>
                        : ''
                    }
                </div>

                {hasdeeds && (
                    <div className="col-span-8 font-semibold">
                        <p className="flex flex-row gap-x-2 mb-2 text-blue-60">Deed 1</p>
                    </div>
                )}

                <div className={`col-span-2 font-semibold ${invalidFields.grantors && 'text-red-600'}`}>Grantor(s): </div>
                <div className="col-span-2 flex-end">{values.grantors}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.book && 'text-red-600'}`}>Book: </div>
                <div className="col-span-2 flex-end">{values.book}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.grantee && 'text-red-600'}`}>Grantee(s) </div>
                <div className="col-span-2 flex-end">{values.grantee}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.page && 'text-red-600'}`}>Page: </div>
                <div className="col-span-2 flex-end">{values.page}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.securingAmountOf && 'text-red-600'}`}>Purchase Price: </div>
                <div className="col-span-2 flex-end">{formatCurrency(values.securingAmountOf)}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.countyRegistry && 'text-red-600'}`}>County Registry: </div>
                <div className="col-span-2 flex-end">{values.countyRegistry}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.dated && 'text-red-600'}`}>Dated: </div>
                <div className="col-span-2 flex-end">{formatDate(values.dated)}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.hasDeed && 'text-red-600'}`}>Upload Copy of Deed: </div>
                <div className="col-span-2 flex-end">{copyofdeed.join(', ')}</div>

                <div className={`col-span-2 font-semibold ${invalidFields.secrecordedOn && 'text-red-600'}`}>Recorded On: </div>
                <div className="col-span-2 flex-end ">{formatDate(values.recordedOn) + " " + time}</div> 

                {hasSecondDeed && (
                    <>
                        <div className="col-span-8 font-semibold mt-2">
                            <p className="flex flex-row gap-x-2 mb-2 text-blue-60">Deed 2</p>
                        </div>

                        <div className={`col-span-2 font-semibold ${invalidFields.secgrantors && 'text-red-600'}`}>Grantor(s): </div>
                        <div className="col-span-2 flex-end">{values.secgrantors}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.secbook && 'text-red-600'}`}>Book: </div>
                        <div className="col-span-2 flex-end">{values.secbook}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.secgrantee && 'text-red-600'}`}>Grantee(s) </div>
                        <div className="col-span-2 flex-end">{values.secgrantee}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.secpage && 'text-red-600'}`}>Page: </div>
                        <div className="col-span-2 flex-end">{values.secpage}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.secsecuringAmountOf && 'text-red-600'}`}>Purchase Price: </div>
                        <div className="col-span-2 flex-end">{formatCurrency(values.secsecuringAmountOf)}</div>


                        <div className={`col-span-2 font-semibold ${invalidFields.seccountyRegistry && 'text-red-600'}`}>County Registry: </div>
                        <div className="col-span-2 flex-end">{values.seccountyRegistry}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.secdated && 'text-red-600'}`}>Dated: </div>
                        <div className="col-span-2 flex-end">{formatDate(values.secdated)}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.seccopyOfDeed && 'text-red-600'}`}>Upload Copy of Deed: </div>
                        <div className="col-span-2 flex-end">{copyofdeedsecond.join(', ')}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.secrecordedOn && 'text-red-600'}`}>Recorded On: </div>
                        <div className="col-span-2 flex-end">{formatDate(values.secrecordedOn)+ " " + sectime}</div>
                    
                    </>
                )}

                {hasDeedOfTrust && (
                    <>
                        <div className="col-span-8 font-semibold mt-2">
                            <p className="flex flex-row gap-x-2 mb-2 text-blue-60">Deed of Trust</p>
                        </div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotmortgators && 'text-red-600'}`}>Mortgagor(s): </div>
                        <div className="col-span-2 flex-end">{values.dotmortgators}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotbeneficiary && 'text-red-600'}`}>Beneficiary: </div>
                        <div className="col-span-2 flex-end">{values.dotbeneficiary}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dottrustee && 'text-red-600'}`}>Trustee: </div>
                        <div className="col-span-2 flex-end">{values.dottrustee}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotsecuringAmountOf && 'text-red-600'}`}>Securing Amount Of: </div>
                        <div className="col-span-2 flex-end">{formatCurrency(values.dotsecuringAmountOf)}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotdated && 'text-red-600'}`}>Dated: </div>
                        <div className="col-span-2 flex-end">{formatDate(values.dotdated)}</div>

                                                
                        <div className={`col-span-2 font-semibold ${invalidFields.dotbook && 'text-red-600'}`}>Book: </div>
                        <div className="col-span-2 flex-end">{values.dotbook}</div>
                        <div className={`col-span-2 font-semibold ${invalidFields.dotrecordedOn && 'text-red-600'}`}>Recorded On: </div>
                        <div className="col-span-2 flex-start">{formatDate(values.dotrecordedOn)+" " +deedoftrusttime}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotcountyRegistry && 'text-red-600'}`}>County Registry: </div>
                        <div className="col-span-2 flex-end">{values.dotcountyRegistry}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotpage && 'text-red-600'}`}>Page: </div>
                        <div className="col-span-2 flex-end">{values.dotpage}</div>

                        <div className="col-span-8 mt-2 mb-2" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}></div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotreRecordedOn && 'text-red-600'}`}>Re-recorded On (If Applicable): </div>
                        <div className="col-span-2 flex-end">{formatDate(values.dotreRecordedOn)+" "+ deedofretrusttime}</div>
                       

                        <div className={`col-span-2 font-semibold ${invalidFields.dotreBook && 'text-red-600'}`}>Book: </div>
                        <div className="col-span-2 flex-end">{values.dotreBook}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotreCountyRegistry && 'text-red-600'}`}>County Registry: </div>
                        <div className="col-span-2 flex-end">{values.dotreCountyRegistry}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotrePage && 'text-red-600'}`}>Page: </div>
                        <div className="col-span-2 flex-end">{values.dotrePage}</div>

                        <div className="col-span-8 mt-2 mb-2" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}></div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotassignedTo && 'text-red-600'}`}>Assigned To: </div>
                        <div className="col-span-2 flex-end">{values.dotassignedTo}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotassignedBook && 'text-red-600'}`}>Book: </div>
                        <div className="col-span-2 flex-end">{values.dotassignedBook}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotassignedCountyRegistry && 'text-red-600'}`}>County Registry: </div>
                        <div className="col-span-2 flex-end">{values.dotassignedCountyRegistry}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.dotassignedPage && 'text-red-600'}`}>Page: </div>
                        <div className="col-span-2 flex-end">{values.dotassignedPage}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.lienOrder && 'text-red-600'}`}>Lien: </div>
                        <div className="col-span-2 flex-end">{values.lienOrder?.label || ''}</div>

                        <div className={`col-span-2 font-semibold ${invalidFields.lienOrder && 'text-red-600'}`}>Upload Copy of Deed of Trust </div>
                        <div className="col-span-2 flex-end">{copyofdeedthird.join(', ')}</div>

                    </>
                )}
            </div>
        </div>
    );
};

export default Review;